import React from "react";
import "./SuportLink.css";

const SuportLink: React.FC = () => {
  return (
    <div className="modal-suport-link">
      <a
        href={process.env.REACT_APP_TIKTOK}
        target="_blank"
        rel="noopener noreferrer"
      >
        Precisa de ajuda? Entre em contato por aqui.
      </a>
    </div>
  );
};

export default SuportLink;
